import { produce } from 'immer';
import { createReducer } from 'typesafe-actions';

import { nextHydrate } from '../actions';
import type { HydrateAction } from '../actions';

import {
  createMultipleWhitelistAction,
  createWhitelistAction,
  deleteWhitelistAction,
  getAllWhitelistAction,
  toggleCreateWhitelist,
} from './actions';
import type { WhitelistAction, WhitelistState } from './types';

export const initialWhitelistState: WhitelistState = {
  createDrawerVisible: false,
  rows: [],
};

export const whitelistReducer = createReducer<
  WhitelistState,
  WhitelistAction | HydrateAction
>(initialWhitelistState)
  .handleAction(getAllWhitelistAction.success, (state, { payload: rows }) =>
    produce(state, (draftState) => {
      draftState.rows = rows;
    })
  )
  .handleAction(createWhitelistAction.success, (state, { payload: row }) =>
    produce(state, (draftState) => {
      draftState.rows?.push(row);
    })
  )
  .handleAction(
    createMultipleWhitelistAction.success,
    (state, { payload: rows }) =>
      produce(state, (draftState) => {
        draftState.rows = draftState.rows?.concat(rows);
      })
  )
  .handleAction(deleteWhitelistAction.success, (state, { payload }) =>
    produce(state, (draftState) => {
      draftState.rows = draftState.rows.filter(
        (row) => row.uuid !== payload.uuid
      );
    })
  )
  .handleAction(toggleCreateWhitelist, (state) =>
    produce(state, (draftState) => {
      draftState.createDrawerVisible = !state.createDrawerVisible;
    })
  )
  .handleAction(nextHydrate, (state, { payload }) => ({
    ...state,
    ...payload.whitelist,
  }));
